/** Refresh cached captures when the deployed portal's appearance changes. */
export const cloudScreenshot = (path: string) => `${path}?v=nexus-1.43.2`;
